import { createFileRoute, notFound } from "@tanstack/react-router";
import homeStyles from "../styles/platform-home.css?url";
import type { StructuredData } from "../../src/lib/structured-data";
import { withStylesheet } from "../lib/head";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { MembershipAppPage } from "../platform/membership-app-page";
import { loadMembershipAppPage } from "../platform/product-pages";

/** Drate's page on making a membership app (/membership-app); a 404 on creator sites. */
export const Route = createFileRoute("/membership-app")({
  loader: async () => {
    const page = await loadMembershipAppPage();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) =>
    loaderData
      ? withStylesheet(
          platformPageHead(platformShellFrom(matches), {
            pathname: "/membership-app",
            title: "Make a membership app for your community | Drate",
            description:
              "Get your own iPhone and Android membership app with your name, icon and colors. Your posts, members-only content and community in one place. No code.",
            canonicalPath: "/membership-app",
            structuredData: JSON.parse(loaderData.structuredData) as StructuredData[],
          }),
          homeStyles,
        )
      : {},
  component: () => <MembershipAppPage page={Route.useLoaderData()} />,
});
